/**
 * Common API
 */

/**
 * 获取验证码
 * '/user/otp/${mobile}'
 */
export const GET_SMS_CODE = '/user/otp/'

/**
 * 获取上传权限
 * 
 */
export const UPLOAD_PERMISS_URL = '/oss/sign'

/**
 * 后端pdf签名接口
 */
export const API_PDF_SIGN = '/pdf'